import styled from 'styled-components';

export const SectionContainer = styled.div``;

export const RestOfMonthContainer = styled.h2`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  margin: 0;
  padding: 0;
`;

export const OverdueActions = styled.div`
  display: flex;
  align-items: center;
`;

export const ExternalEventsContainer = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing(0.5)} ${theme.spacing(1.5)} ${theme.spacing(1)} ${theme.spacing(3.5)}`};
`;
